import words from '../data/words.json';

export const CATEGORIES = [...new Set(words.map(w => w.category))];

export const getRandomWord = (category) => {
    const filteredWords = category === 'все'
        ? words
        : words.filter(word => word.category === category);
    if (filteredWords.length === 0) return null;
    return filteredWords[Math.floor(Math.random() * filteredWords.length)];
};
